<!-- 消防 -->
<style lang="scss" scoped>
.fire {
  position: relative;

  .returnScence {
    position: absolute;
    width: 144px;
    height: 56px;
    left: 536px;
    top: 135px;
    cursor: pointer;
    background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

    &:hover {
      background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
    }
  }
  .returnScence2 {
    position: absolute;
    width: 144px;
    height: 56px;
    left: 536px;
    top: 213px;
    cursor: pointer;
    background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

    &:hover {
      background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
    }
  }

  .dialog {
    position: absolute;
    top: 135px;
    right: 43px;
    width: 416px;
  }
}
</style>

<template>
  <div class="fire">
    <div class="returnScence" @click="returnScence"></div>
    <!-- <div
      class="returnScence2"
      @click="returnScence2"
      v-show="isShowParkingNormal"
    ></div> -->
    <!-- <FireDialog v-show="isShowDialog" :infor="infor"></FireDialog> -->
    <div class="dialog" v-show="isShowDialog">
      <pannel-box :headerName="'烟感'" :headerData="infor" :isShowMinor="true">
        <div
          class="contentList"
          v-for="(item, key, index) in monitorList"
          :key="index"
        >
          <div class="text">{{ key }}</div>
          <div class="value">{{ item }}</div>
        </div>
      </pannel-box>
    </div>
    <WaterPump
      :data="data"
      :pumpList="pumpList"
      @closeDialog="closeDialog"
    ></WaterPump>
    <template v-if="isIntoWaterPump">
      <SmoothFeel :number1="number1" :number2="number2"></SmoothFeel>
      <FireDoor :openNum="openNum" :closeNum="closeNum"></FireDoor>
    </template>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
import WaterPump from "./components/water-pump.vue";
import SmoothFeel from "./components/smooth-feel.vue";
import FireDoor from "./components/fire-door.vue";
import FireDialog from "./components/fire-dialog.vue";
import { getFireControlData, getEqpInfo } from "@/api/index";
export default {
  data() {
    return {
      // 烟感数据
      number1: 0,
      number2: 0,
      // 消防卷帘门数据
      openNum: 0,
      closeNum: 0,
      data: {}, //水泵及水池水位
      pumpList: [
        //水泵数据
        { title: "正常数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      isShowDialog: false,
      infor: {}, //弹框数据
      monitorList: {},
      isShowParkingNormal: false,
      XF: {},
      timer: null,
    };
  },
  components: { WaterPump, SmoothFeel, FireDoor, FireDialog },
  computed: {
    isIntoWaterPump() {
      if (Number(this.$route.params.id)) return false;
      else return true;
    },
  },
  mounted() {
    this.$store.state.threeEvent.intoFire = true;
    bus.emit("openFloorLabel", true);
    bus.emit("showFloorPoint", "烟感", true);
    bus.on("dialogNumber", this.showDialogContainer);
    bus.on("parkingArea2", this.clickParking);
  },
  methods: {
    clickParking() {
      this.isShowParkingNormal = true;
    },
    async showDialogContainer(eqpCode) {
      let { data: res } = await getEqpInfo({ eqpCode });
      this.infor = res.baseData;
      this.XF = res.baseData;
      this.monitorList = res.collectionValue?.data;
      this.isShowDialog = true;
    },
    // 进入场景隐藏弹框
    closeDialog(e) {
      this.isShowDialog = e;
    },
    returnScence() {
      this.$store.state.threeEvent.intoFireUnder = false;
      if (this.isShowDialog) {
        this.isShowDialog = false;
      }
      // 离开地下
      if (this.isIntoWaterPump) {
        console.log("重置视角");
        bus.emit("back");
      } else {
        console.log("离开地下");
        // bus.emit("underground", this.isIntoWaterPump);
        bus.emit("changeScene", "up");
        // bus.emit("backB3");
        this.$router.push({
          name: "fourth-fourth",
          path: "/firecontrol",
          params: { id: 0 },
        });
      }
    },
    returnScence2() {
      bus.emit("parking-mr");
      this.isShowParkingNormal = false;
    },
    async ReqFireData() {
      let { data: res } = await getFireControlData();
      // 顶层水池
      this.data.level = res.atticTank.level.value.split("m")[0];
      this.data.levelStatus = res.atticTank.level.alarm;
      this.data.levelUpperLimit = res.atticTank.levelUpperLimit;
      // 消防水泵数据
      this.pumpList[0].num = res?.firePump?.normal;
      this.pumpList[1].num = res?.firePump?.standy;
      this.pumpList[2].num = res?.firePump?.fault;
      this.data.SBYE = res?.firePump?.levelUpperLimit;
      this.data.SBDQYE = res?.firePump?.level.value.split("m")[0];
      this.data.SBDQYEStatus = res?.firePump?.level.alarm;

      // 烟感数据
      let arr1 = res.smokeDetector.filter((item) => {
        return item.buildNo.includes("total");
      });
      for (const value of arr1) {
        this.number1 = value.normal;
        this.number2 = value.fault;
      }

      // 消防卷帘门数据
      let arr2 = res.fireDoor.filter((item) => {
        return item.buildNo.includes("total");
      });
      for (const value of arr2) {
        this.openNum = value.normal;
        this.closeNum = value.fault;
      }
    },
  },
  created() {
    this.ReqFireData();
    this.timer = setInterval(() => {
      this.ReqFireData();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
